import http from 'services/http';
import type { Feedback, FeedbackInput, TestFeedbackReport } from './types';

/** Null while the learner has not left any. A 404 (not their attempt) is an error the caller treats as "show nothing". */
export async function getAttemptFeedback(attemptId: string, signal?: AbortSignal): Promise<Feedback | null> {
  const { data } = await http.request.get<{ data: Feedback | null }>(
    `/api/feedback/attempts/${encodeURIComponent(attemptId)}`,
    { signal },
  );
  return data.data;
}

export async function saveAttemptFeedback(attemptId: string, input: FeedbackInput): Promise<Feedback> {
  const { data } = await http.request.put<{ data: Feedback }>(
    `/api/feedback/attempts/${encodeURIComponent(attemptId)}`,
    input,
  );
  return data.data;
}

/** What learners said about one test of the active organization (the X-Organization-Id header is added by the client). */
export async function getTestFeedback(
  testId: string,
  params: { page: number; limit: number },
  signal?: AbortSignal,
): Promise<TestFeedbackReport> {
  const { data } = await http.request.get<{ data: TestFeedbackReport }>(
    `/api/feedback/tests/${encodeURIComponent(testId)}`,
    { params, signal },
  );
  return data.data;
}
